<template>
  <PageSeoData
    :title="
      $t('page_seo_data.facilities.title')
    "
    :description="
      $t('page_seo_data.facilities.description')
    "
  >
    <template #scripts
    ><Link
      rel="stylesheet"
      :href="'https://api.mapbox.com/mapbox-gl-js/v3.24.0/mapbox-gl.css'"
      fetchpriority="low"
      defer
    /></template>
  </PageSeoData>
  <FacilitiesSection />
</template>

<script setup lang="ts">
import FacilitiesSection from "~/components/sections/FacilitiesSection.vue";
import PageSeoData from "~/components/pageSeoData/PageSeoData.vue";
</script>
